import { useState } from "react";
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { ToggleOffOutlined, ToggleOnOutlined } from "@mui/icons-material";

import { CancelButton } from "../../css components/Button";
import languageTranslator from "../../../utils/languageTranslator";

export default function LiveUserDialog({ dialogState, setDialogState }) {
  const [language, setLanguage] = useState("en");

  const handleClose = () => {
    setDialogState({ ...dialogState, state: false });
  };

  return (
    <Dialog open={dialogState.state} onClose={handleClose}>
      <DialogTitle style={{ paddingBottom: "0px" }}>
        <div style={{ justifyContent: "end", display: "flex" }}>
          <div style={{ display: "flex" }}>
            <Typography>EN</Typography>
            <Checkbox
              style={{
                padding: "3px 9px",
                position: "relative",
                top: "-9px",
              }}
              onChange={(e) => {
                if (e.target.checked) {
                  setLanguage("id");
                } else {
                  setLanguage("en");
                }
              }}
              icon={<ToggleOffOutlined fontSize="large" />}
              checkedIcon={
                <ToggleOnOutlined fontSize="large" style={{ color: "red" }} />
              }
            />
            <Typography>ID</Typography>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Typography>
            {languageTranslator(
              "The campaign offer cannot be accepted since there are no matching users found for requested attributes",
              language
            )}
          </Typography>
        </DialogContentText>
      </DialogContent>

      <DialogActions style={{ padding: "0px 24px 16px" }}>
        <CancelButton onClick={handleClose} variant="outlined" autoFocus>
          Cancel
        </CancelButton>
      </DialogActions>
    </Dialog>
  );
}
